<template>
  <div class="async-spinner-wrap">
    <font-awesome-icon icon="spinner" pulse aria-label="Loading..."/>
  </div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    components: {
      FontAwesomeIcon
    }
  }
</script>
